var carrersFilters = {
    init: function($target) {
        $('.careers-list-filters-item').removeClass('active');
        $('.careers-list-filters-item[data-category-type="'+$target+'"]').addClass('active');
        var caller = $('.careers-list-filters-item[data-category-type="'+$target+'"]'),
            partial = $('.careers-list');
            partial.data('category_type',$target);
            load_partial(partial);
    }
}